import React from "react";
import classnames from "classnames";
import { FiChevronRight } from "react-icons/fi";

import "./SelectBox.scss";

interface SelectBoxProps {
  letter?: string;
  label?: string;
  description?: string;
  isSelected?: boolean;
  onSelect?: React.MouseEventHandler<HTMLDivElement>;
  items?: React.ReactNode[];
  ordered?: boolean;
  displayChevron?: boolean;
  defaultSelected?: boolean;
  children?: React.ReactNode;
}

const SelectBox = (props: SelectBoxProps) => {
  const {
    items,
    ordered,
    defaultSelected,
    onSelect,
    isSelected,
    label,
    description,
    displayChevron,
    children,
  } = props;
  const ListType = ordered ? "ol" : "ul";

  return (
    <div className="select-box-container" onClick={onSelect}>
      <div
        className={classnames("select-box ", {
          selected: isSelected || defaultSelected ? "selected" : "",
        })}
      >
        <div className="description-box">
          <p className="label">{label}</p>
          <p className="description">{description}</p>
          {items && items.length > 0 && (
            <ListType className="list">
              {items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ListType>
          )}

          <div>{children}</div>
        </div>
        {displayChevron && (
          <div style={{ paddingRight: 5 }}>
            <FiChevronRight stroke={"#5E6B75"} size={14} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectBox;
